import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Subject } from 'rxjs';
import { AdminContextProvider, AdminEditedPageLeaveContextProvider, } from "../../contexts/context";
import { Sidebar } from '../sidebar';
export const NavSidebar = ({ navigateTo, onTabChange, oneMindModalComponent, ...blinkContext }) => {
    const purchaseCompleteSubject = useRef(new Subject());
    const tabSwitchHandlerRef = useRef(null);
    const wrappedNavigateTo = useCallback((url, isIframeUrl) => {
        navigateTo(url, isIframeUrl);
    }, [navigateTo]);
    const handleRegisterTabSwitcher = useCallback((handler) => {
        tabSwitchHandlerRef.current = handler;
    }, []);
    useEffect(() => {
        const adminTabSwitcher = blinkContext?.navService?.adminTabSwitcher;
        if (!adminTabSwitcher) {
            return undefined;
        }
        adminTabSwitcher.registerCb((tabId) => {
            if (tabSwitchHandlerRef.current) {
                tabSwitchHandlerRef.current(tabId);
            }
        });
        return () => {
            adminTabSwitcher.deregisterCb();
        };
    }, [blinkContext?.navService]);
    const defaultTeamComponents = useMemo(() => ({
        adminTabSwitcher: {
            registerCb: () => {
            },
            deregisterCb: () => {
            },
        },
        purchaseCompleteObserver: purchaseCompleteSubject.current,
    }), []);
    useEffect(() => {
        return () => {
            purchaseCompleteSubject.current.complete();
        };
    }, []);
    return (React.createElement(AdminEditedPageLeaveContextProvider, null,
        React.createElement(AdminContextProvider, { rootPath: "/admin", teamComponents: defaultTeamComponents, ...blinkContext, OneMindModalComponent: oneMindModalComponent },
            React.createElement(Sidebar, { navigateTo: wrappedNavigateTo, onTabChange: onTabChange, onRegisterTabSwitcher: handleRegisterTabSwitcher }))));
};
//# sourceMappingURL=nav-sidebar.container.js.map